import React from 'react';
var WrapWidth = React.forwardRef(function (_a, ref) {
    var width = _a.width, children = _a.children;
    return (React.createElement("div", { ref: ref, style: { width: width } }, children));
});
WrapWidth.displayName = 'WrapWidth';
export default WrapWidth;
//# sourceMappingURL=WrapWidth.js.map